import { z } from 'zod'
import { isValidPhone } from '@/helpers'
import { validateCpf, validateCnpj } from '@/helpers/validations'
import { addressSchema } from '../../../address-form/schema'

const baseSchema = z.object({
  name: z.string().min(1, 'Obrigatório'),
  email: z.string().optional(),
  phone: z.string()
    .optional()
    .refine(
      (value) => value === undefined || value === '' || isValidPhone(value),
      'Telefone inválido',
    ),
  no_address: z.boolean(),
  address: z.union([addressSchema, z.undefined()]).optional(),
})

const cpfSchema = baseSchema.extend({
  tax_id_type: z.literal('cpf'),
  tax_id: z.string().refine(validateCpf, { message: 'Digite um CPF válido' }),
})

const cnpjSchema = baseSchema.extend({
  tax_id_type: z.literal('cnpj'),
  tax_id: z.string().refine(validateCnpj, { message: 'Digite um CNPJ válido' }),
})

const createModeSchema = z.discriminatedUnion('tax_id_type', [
  cpfSchema,
  cnpjSchema,
])

const refinedSchema = (schema: z.ZodTypeAny) =>
  schema.superRefine((data, ctx) => {
    if (!data.no_address) {
      if (!data.address) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Obrigatório',
          path: ['address'],
        })
        return
      }

      const result = addressSchema.safeParse(data.address)
      if (!result.success) {
        for (const issue of result.error.issues) {
          ctx.addIssue({
            path: ['address', ...(issue.path ?? [])],
            code: issue.code,
            message: 'Obrigatório',
          } as z.IssueData)
        }
      }
    }
  })

export const createBorrowerRegistrationFormSchema = (
  mode: 'create' | 'edit',
) => {
  const schema = mode === 'create' ? createModeSchema : baseSchema
  return refinedSchema(schema)
}

export type BorrowerRegistrationFormData = z.infer<
  ReturnType<typeof createBorrowerRegistrationFormSchema>
>
